import { Component, OnInit, ViewEncapsulation, Input, OnDestroy, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormArray, FormControl } from '@angular/forms';
import { TweenMax, Quint } from 'gsap';
import { EventTypes } from '../../../shared/EventTypes';
import { AppEventDispatcher } from '../../../utils/AppEventDispatcher';
import { TransactionHistoryService } from '../transaction-history.service';
import { Auth } from '../../../autentication/Auth';
import { TransactionHistoryEventType } from '../transaction-history.event.type';
import { Transaction } from '../models/transaction';
import { ThemeService } from '../../../shared/theme-service/theme.service';
import { ListItem } from '../../../shared/list-confirmation/model/list-item';


@Component({
	selector: 'app-transaction-summary',
	templateUrl: './transaction-summary.component.html',
	styleUrls: ['./transaction-summary.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class TransactionSummaryComponent implements OnInit, OnDestroy {

	view = '[data-component="transaction-summary"]';
	formReason: FormGroup;
	formSignature: FormGroup;
	active = false;
	isAttendant = false;
	scheduledTransaction: boolean;
	sendConfirmedTransaction = false;

	@Input() summaryList: Array<Transaction> = [];
	@Output() setForm: EventEmitter<FormGroup> = new EventEmitter<FormGroup>();
	@Output() showStepButtons: EventEmitter<boolean> = new EventEmitter<boolean>();

	constructor(private service: TransactionHistoryService, private themeService: ThemeService) {
		this.formReason = new FormGroup({
			reasons: new FormArray([]),
		});
	}

	ngOnInit() {
		this.isAttendant = this.themeService.isAttendant();
		this.addListeners();
	}

	private addListeners() {
		AppEventDispatcher.listen(TransactionHistoryEventType.HISTORY.RESUME, (data) => {
			this.showStepButtons.emit(false);

			this.preload(true);
			this.summaryList = data.list;

			this.scheduledTransaction = data.scheduledTrasaction;

			for (let i = 0; i < this.summaryList.length; i++) {
				if (this.summaryList[i].typeTransaction === 'Pacotes') {
					this.getDetailsPackage(i);
				}
				if (this.summaryList[i].typeTransaction === 'Boleto' && this.summaryList[i].useNewLimit) {
					this.getDatailsBillet(i);
				}
				else {
					this.getDatailsTransactions(i);
				}
			}
		});
	}

	getDatailsBillet(i: number) {
		const trans: Transaction = this.summaryList[i];
		trans.details.push(new ListItem('Valor:', trans.value.toString(), 'cls_mask'));
		trans.details.push(new ListItem('Vencimento:', trans.debitDate));
		this.reasons.push(new FormControl());

		setTimeout(() => {
			if (i === this.summaryList.length - 1) {
				this.active = true;
				this.show();
				this.setSendListener();
				this.preload(false);
			}
		}, 1000);
	}

	getDatailsTransactions(i: number) {
		this.reasons.push(new FormControl());
		setTimeout(() => {
			if (i === this.summaryList.length - 1) {
				this.active = true;
				this.show();
				this.setSendListener();
				this.preload(false);
			}
		}, 1000);

		if(this.summaryList[i].useNewLimit){ return }

		this.service.getDetails(this.summaryList[i]).subscribe(sums => {
			this.summaryList[i].details = sums;
		}, error => {
			AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
			this.preload(false);
		});
	}

	getDetailsPackage(i: number) {
		this.service.getDetailsPackages(this.summaryList[i]).subscribe(sums => {
			this.summaryList[i].details = sums;
			this.reasons.push(new FormControl());

			setTimeout(() => {
				if (i === this.summaryList.length - 1) {
					this.active = true;
					this.show();
					this.setSendListener();
					this.preload(false);
				}
			}, 1000);

		}, error => {
			AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
			this.preload(false);
		});
	}

	get reasons(): FormArray { return this.formReason.get('reasons') as FormArray; }

	show() {
		const interval = setInterval(() => {
			if ($(this.view).length > 0) {
				TweenMax.to(this.view, .8, { delay: .4, left: 0, ease: Quint.easeOut });
				clearInterval(interval);
			}
		}, 10);
	}

	setSendListener() {
		AppEventDispatcher.listen(TransactionHistoryEventType.TRANSACTION_HISTORY_SEND, () => {
			this.hide();
		});
	}

	hide() {
		for (let i = 0; i < this.summaryList.length; i++) {

			if (!this.reasons.controls[i].value && this.summaryList[i].statusCode === 2) {

				this.reasons.controls[i].setErrors({ 'required': true });
				this.reasons.setErrors({ 'required': true });

				AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: 'Informe o motivo para reprovação da transação!' });
				this.preload(false);
			} else {
				if (this.reasons.controls[i]) {
					this.summaryList[i].reason = this.reasons.controls[i].value;
					this.reasons.controls[i].setErrors({ 'required': false });
				}
			}
			if ((i === this.summaryList.length - 1) && (!this.reasons.errors)) {
				this.send();
			}
		}

	}

	addAuthToken() {
		Auth.passToken = this.formSignature.value.token ? this.formSignature.value.token : '';
		Auth.assinaturaEletronica = this.formSignature.value.eletronicSignature ? this.formSignature.value.eletronicSignature : '';
	}

	send() {
		if (this.formSignature.valid) {

			this.removeListeners();
			this.preload(true);

			this.service.passwordValidate(this.formSignature.controls.eletronicSignature.value).subscribe(() => {

				this.addAuthToken();

				this.service.sendChanges(this.summaryList).subscribe(data => {
					this.preload(false);

					AppEventDispatcher.dispatch(TransactionHistoryEventType.HISTORY.BEGIN, { show: false });
					TweenMax.to(this.view, .8, {
						delay: .4, left: '-100%', ease: Quint.easeOut, onComplete: () => {
							this.active = false;
						}
					});
					if (this.scheduledTransaction) {
						AppEventDispatcher.dispatch(TransactionHistoryEventType.HISTORY.TRANSACT_END, {
							show: true, messages: ['Transação cancelada com sucesso!'],
							success: true
						});
					} else {
						const messages = data.Mensagem.split('\n');
						AppEventDispatcher.dispatch(TransactionHistoryEventType.HISTORY.TRANSACT_END, { show: true, messages: messages, success: true });
					}
					AppEventDispatcher.dispatch(TransactionHistoryEventType.BUTTONS, { show: true });
				}, error => {
					this.preload(false);

					if (error.error.Tipo !== 'tokenDatablinkValidado') {
						AppEventDispatcher.dispatch(TransactionHistoryEventType.HISTORY.BEGIN, { show: false });
						TweenMax.to(this.view, .8, {
							delay: .4, left: '-100%', ease: Quint.easeOut, onComplete: () => {
								this.active = false;
							}
						});
						AppEventDispatcher.dispatch(TransactionHistoryEventType.HISTORY.TRANSACT_END,
							{ show: true, messages: [error.error.Mensagem], success: false });
						AppEventDispatcher.dispatch(TransactionHistoryEventType.BUTTONS, { show: true });
					} else {
						AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
						this.setSendListener();
					}
				});

			}, error => {

				AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
				this.preload(false);
				this.setSendListener();

			});
		} else {
			AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: 'Informe a assinatura eletrônica!' });
			this.preload(false);
			this.setSendListener();
		}
	}

	ngOnDestroy() {
		this.removeListeners();
	}

	removeListeners() {
		AppEventDispatcher.removeListener(TransactionHistoryEventType.HISTORY.RESUME);
		AppEventDispatcher.removeListener(TransactionHistoryEventType.TRANSACTION_HISTORY_SEND);
	}

	preload(active, delay = 0) {
		AppEventDispatcher.dispatch(EventTypes.PRELOAD,
			{ element: '[data-component="transaction-history"] .content', show: active, delay: delay });
	}

	onSetSignatureForm(form: FormGroup) {
		this.formSignature = form;
		this.setForm.emit(this.formSignature);

		if (this.sendConfirmedTransaction) {
			this.send();
		}
	}

	getMessageConfirmedTransaction(message: boolean) {
		this.sendConfirmedTransaction = message;
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/transaction-history/transaction-summary/transaction-summary.component.ts